import _ from 'lodash';

export const calcPercent = (progress: number | null, total: number | null) => {
  if (!progress || !total) { return 0; }
  return _.toInteger((progress / total) * 100);
};
